
import { Options, Vue } from 'vue-property-decorator';
import FloatingTool from './FloatingTool.vue';

@Options({
  components: { FloatingTool },
})
export default class NotepadTool extends Vue {
  private maxCount = 1000;
  private characterCount = '0/' + this.maxCount;

  mounted() {
    this.$el.querySelector('#textarea').addEventListener('keyup', () => this.handleCharacterCount());
  }

  unmounted() {
    this.$el.querySelector('#textarea').removeEventListener('keyup', () => this.handleCharacterCount());
  }

  private handleCharacterCount(): void {
    const textArea: HTMLInputElement = this.$el.querySelector('#textarea');
    const len: number = textArea.value.length;
    if (len > this.maxCount) {
      textArea.value = textArea.value.substring(0, this.maxCount);
      textArea.innerHTML = `${this.maxCount}/${this.maxCount}`;
    } else {
      this.characterCount = `${len}/${this.maxCount}`;
    }
  }

  private handleSectionChange(): void {
    this.clearNotepad();
  }

  private clearNotepad(): void {
    this.$el.querySelector('#textarea').value = '';
    this.characterCount = `0/${this.maxCount}`;
  }
}
